import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import JournalDigestInfo from 'donor-elf-web/lib/models/journal-digest-info';
import JournalGroupModel from 'donor-elf-web/models/all-funds/journal-group';
import JournalGroupUserSettingModel from 'donor-elf-web/models/all-funds/journal-group-user-setting';
import FormatDateService from 'donor-elf-web/services/format-date-service';
import FundsService from 'donor-elf-web/services/funds-service';

export default class JournalGroupIndexRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare formatDateService: FormatDateService;
  @service declare store: Store;

  async model(): Promise<JournalGroupIndexRouteModel> {
    let { journalGroup } = this.modelFor(
      'funds.all.journal-groups.journal-group',
    ) as JournalGroupIndexRouteModel;
    let journalGroupUserSetting = (
      await this.store.query('all-funds/journal-group-user-setting', {
        filter: { journal_group_id: journalGroup.id },
      })
    ).slice()[0];
    let journals = (
      await this.store.query('all-funds/journal-slim', {
        filter: { journal_group_id: journalGroup.id },
      })
    ).slice();

    return {
      journalGroup,
      journalGroupUserSetting,
      journalDigestInfos: sortByProperties(
        journals.map((x) =>
          new JournalDigestInfo(
            x,
            this.store,
            this.fundsService,
            this.formatDateService,
          )
        ),
        ['journalSlim.fundName:asc', 'journalSlim.label']
      ),
    };
  }
}

export class JournalGroupIndexRouteModel {
  journalGroup!: JournalGroupModel;
  journalGroupUserSetting?: JournalGroupUserSettingModel;
  journalDigestInfos!: JournalDigestInfo[];
}
